import * as React from 'react';
import { css } from 'aphrodite';

import styles from './onboardingFormIconStyles';

export default class LoanSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.positioning)}
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <title>icon_loan</title>
        <defs />
        <g
          id="icon_loan"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="database" transform="translate(3.000000, 2.000000)" stroke="#757575" strokeWidth="1.6">
            <ellipse id="Oval" cx="7" cy="2.4" rx="7" ry="2.4" />
            <path d="M14,6 C14,7.328 10.8888889,8.4 7,8.4 C3.11111111,8.4 0,7.328 0,6" id="Shape" />
            <path d="M14,10 C14,11.328 10.8888889,12.4 7,12.4 C3.11111111,12.4 0,11.328 0,10" id="Shape-Copy" />
            <path d="M0,2.4 L0,13.6 C0,14.928 3.11111111,16 7,16 C10.8888889,16 14,14.928 14,13.6 L14,2.4" id="Shape" />
          </g>
        </g>
      </svg>
    );
  }
}
